/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description OK
 */
export const postApiCostcenters200Schema = z.any();

export const postApiCostcentersMutationRequestSchema = z.object({
  name: z.coerce.string().min(1).max(500),
  client: z.object({
    value: z.coerce.number().int(),
    label: z.coerce.string(),
  }),
  isVisible: z.boolean(),
});

export const postApiCostcentersMutationResponseSchema = z.lazy(
  () => postApiCostcenters200Schema,
);
